"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Textarea = void 0;
/*
 * © 2025 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
const styled_components_1 = require("../styled-components");
exports.Textarea = styled_components_1.styled.textarea `
  flex: 0 0 auto;
  width: 100%;
  resize: none;
  background: ${({ theme }) => theme.inputBg};
  padding: 5px ${(props) => (props.clearButton ? "20px" : "10px")} 5px 10px;
  padding: 5px ${(props) => (props.clearButton ? "20px" : "10px")} 5px 10px;
  box-shadow: inset 0 1px 1px #000d;
  min-width: ${(props) => { var _a; return (_a = props.minWidth) !== null && _a !== void 0 ? _a : "30px"; }};
  min-height: ${(props) => { var _a; return (_a = props.minHeight) !== null && _a !== void 0 ? _a : "30px"; }};
  border: none;
  border-radius: ${({ theme }) => theme.radius};
  color: ${({ theme }) => theme.fg};
  font-family: inherit;
  font-size: inherit;
  &:disabled {
    opacity: 0.5;
  }
  &::-ms-clear {
    /* Hide the native IE/Edge clear button */
    visibility: hidden;
  }
  &::-ms-reveal {
    display: none;
  }
`;
//# sourceMappingURL=Textarea.js.map